export function calculateAge(value: string) {
  const today = new Date();
  const dob = new Date(value);

  const timeDiff = today.getTime() - dob.getTime();

  return Math.floor(timeDiff / (1000 * 60 * 60 * 24 * 365));
}
